export default "/images/hourglass-bottom.svg";